module.exports = __webpack_public_path__ + "static/media/education_video.ab6cac0f.mp4";